<div class="estornar row direction-column align-center justify-space-between">
  <app-svg-icon
    class="close-modal"
    src="/assets/icons/close-icon.svg"
    width="25px"
    height="25px"
    color="arrowGray"
    (click)="close()"></app-svg-icon>

  <div *ngIf="hasSelectedContracts" class="estornar-title pb-32" mat-dialog-title>
    {{ title }}
  </div>

  <div class="estornar-cards d-flex direction-column justify-center align-center mt-8 row-gap-10">
    <ng-container *ngIf="contractsToRefund.length > 0">
      <ng-container *ngFor="let contrato of contractsToRefund">
        <div class="card d-flex row align-center">
          <app-estornar-contract-card
            class="row"
            [contract]="contrato"></app-estornar-contract-card>

          <app-svg-icon
            class="btn-trash ml-18"
            src="../../../assets/icons/trash-red.svg"
            width="20px"
            height="22px"
            color="dangerRed"
            (click)="removeReverseContract(contrato)">
          </app-svg-icon>
        </div>
      </ng-container>


      <div style="width: 100%;" [formGroup]="form" *ngIf="!reverseTransfer">
        <div class="d-flex direction-column flex-1" style="width: 50%;">
          <label [attr.for]="reasonSelect.selectId" style="font-size: 14px;font-weight: 600;padding: 5px;">Motivo:</label>
          <app-c-select
            #reasonSelect
            width="100%"
            height="40px"
            placeholder="Selecione"
            alignItem="flex-start"
            formControlName="ReversalReason"
            [data]="reasonOpts"></app-c-select>
        </div>
      </div>

    </ng-container>

    <span class="nao-selecionado" *ngIf="contractsToRefund.length === 0">
      Não há contrato(s) selecionado(s).
    </span>
  </div>

  <div class="estornar-buttons buttons d-flex justify-space-between pt-24">
    <button class="buttons-cancel ui-btn ui-btn--secondary" (click)="close()">
      {{ cancel }}
    </button>
    <button class="buttons-confirm ui-btn ui-btn--primary" (click)="refundContracts()">
      {{ confirm }}
    </button>
  </div>
</div>